module.exports = __webpack_public_path__ + "img/statistics-mockup.c3f223af.png";